import { http } from './client';
import type { ModuleManifest } from '@cavicode/network-ui';

/** Catalog item from BFF GET /api/module-catalog (config-based list). */
export interface ModuleCatalogItem {
    id: string;
    displayName: string;
    description: string;
    category: string;
    icon: string;
    gitUrl: string;
    branch: string;
}

/**
 * API для загрузки модульных манифестов и каталога.
 * BFF (Controller) отдаёт:
 *   GET /api/modules → ModuleManifest[] (установленные модули)
 *   GET /api/module-catalog → ModuleCatalogItem[] (доступные модули из config)
 */
export const modulesApi = {
    /** Установленные модули (manifest'ы для router/nav). */
    async list(): Promise<ModuleManifest[]> {
        const { data } = await http.get<ModuleManifest[]>('/modules');
        return data;
    },

    /** Каталог доступных модулей из BFF config (appsettings.json ModuleCatalog). */
    async catalog(): Promise<ModuleCatalogItem[]> {
        const { data } = await http.get<ModuleCatalogItem[]>('/module-catalog');
        return data;
    }
};
